import { appIdentity } from "@mideye/design-tokens";

export const API_PORTAL_APP_NAME = "Mideye API Portal";

export function ApiPortalIcon() {
  return (
    <svg viewBox={appIdentity.icon.viewBox} fill="currentColor" aria-hidden="true">
      <path d={appIdentity.apps.portal.icon.path} />
    </svg>
  );
}

export function EamIcon() {
  return (
    <svg viewBox={appIdentity.icon.viewBox} fill="currentColor" aria-hidden="true">
      <path d={appIdentity.apps.eam.icon.path} />
    </svg>
  );
}
